import Load from 'components/Load';
import LoadingDots from 'components/LoadingDots';
import LoggedOut from 'components/environments/LoggedOut';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import AppBottomPushDown from 'modules/common/Navbar/PushDown/AppBottomPushDown';
import Notfound from 'modules/errorpages/Notfound';
import React from 'react';
import {
  Redirect,
  Route,
  Switch,
  useParams,
  useRouteMatch,
} from 'react-router-dom';
import { generatePathnameWithLangCode } from 'utils/RouteHelper';
import basePath from 'utils/basePath';
import { useUser } from '~/authentication/store';
import { useLang } from '~/stores/i18n';

import TransferBookingModals from './TransferBookingModals';
import { TransferBookingContextProvider } from './context/TransferBookingContext';

const TransferBooking = Load(
  () =>
    import(
      /* webpackChunkName: "host-transfer-booking" */ './TransferBookingPage'
    ),
);

const SubRoutes = () => {
  const { path } = useRouteMatch();
  const { isHost, isAdmin, isLoggedIn, loading } = useUser();
  const { transferRequestId } = useParams<{ transferRequestId: string }>();
  const lang = useLang();

  if (!loading && !isLoggedIn) {
    return (
      <LoggedOut title="Your updates will show up here. Join Withlocals" />
    );
  }

  if (loading) {
    return <LoadingDots />;
  }

  if (!isHost && !isAdmin) {
    return <Redirect to={generatePathnameWithLangCode('/', lang)} />;
  }

  return (
    <TransferBookingContextProvider transferRequestId={transferRequestId}>
      <Switch>
        <NavigationableLayout
          key="host-transfer-booking"
          path={`${path}/`}
          hideFooter
          noNavbar
          showZendesk={false}
          component={TransferBooking}
        />
        <Route>
          <Notfound />
        </Route>
      </Switch>
      <TransferBookingModals />
    </TransferBookingContextProvider>
  );
};

const routes = (
  <Route path={`${basePath}/host/transfer-booking/:transferRequestId`}>
    <>
      <SubRoutes />
      <AppBottomPushDown />
    </>
  </Route>
);

export default routes;
